// ── Form Inputs ──
export const inputClass = "w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-white/20 focus:outline-none focus:border-sky-500/50 focus:ring-1 focus:ring-sky-500/30 transition-colors";
export const selectClass = inputClass;
export const textareaClass = inputClass + " resize-vertical";

// ── Buttons ──
export const btnPrimary = "bg-sky-600 hover:bg-sky-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors";
export const btnSecondary = "bg-white/10 hover:bg-white/15 text-white/70 px-4 py-2 rounded-lg text-sm font-medium transition-colors";
export const btnDanger = "bg-red-600/80 hover:bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors";
export const btnSuccess = "bg-emerald-600 hover:bg-emerald-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors";
export const btnWarning = "bg-amber-600 hover:bg-amber-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors";
export const btnSmall = "px-3 py-1.5 rounded-md text-xs font-medium transition-colors";
export const btnIcon = "p-2 rounded-lg hover:bg-white/10 text-white/40 hover:text-white transition-colors";

// ── Layout ──
export const cardClass = "bg-white/[0.03] border border-white/10 rounded-xl";
export const cardHeader = "px-5 py-4 border-b border-white/10 flex items-center justify-between";
export const cardBody = "p-5";
export const sectionTitle = "text-xs font-semibold uppercase tracking-wider text-white/30 mb-3";
export const pageTitle = "text-2xl font-bold text-white";
export const pageSubtitle = "text-sm text-white/40";

// ── Tables ──
export const tableHeaderClass = "text-left text-xs uppercase tracking-wider text-white/30 font-medium py-3 px-4";
export const tableCellClass = "py-3 px-4 text-sm text-white/70";
export const tableRowHover = "hover:bg-white/[0.03] transition-colors";

// ── Status ──
export const statusColors = {
  Active: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  Approved: "bg-sky-500/15 text-sky-400 border-sky-500/20",
  Pending: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  Draft: "bg-white/10 text-white/50 border-white/10",
  Cancelled: "bg-red-500/15 text-red-400 border-red-500/20",
  Closed: "bg-white/5 text-white/30 border-white/5",
  Received: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  "Partially Received": "bg-amber-500/15 text-amber-400 border-amber-500/20",
  Paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  Partial: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  Unpaid: "bg-red-500/15 text-red-400 border-red-500/20",
};

// ── Tabs ──
export const tabList = "flex gap-1 p-1 bg-white/[0.03] border border-white/10 rounded-lg";
export const tabActive = "flex-1 py-2 px-3 rounded-md text-xs font-semibold text-sky-400 bg-sky-500/15 transition-colors text-center";
export const tabInactive = "flex-1 py-2 px-3 rounded-md text-xs font-medium text-white/40 hover:text-white/60 hover:bg-white/5 transition-colors cursor-pointer text-center";

// ── Info / Alert Panels ──
export const infoPanel = "p-4 rounded-lg border text-sm";
export const infoPanelBlue = "bg-sky-500/[0.06] border-sky-500/15 text-sky-300";
export const infoPanelAmber = "bg-amber-500/[0.06] border-amber-500/15 text-amber-300";
export const infoPanelRed = "bg-red-500/[0.06] border-red-500/15 text-red-300";
export const infoPanelGreen = "bg-emerald-500/[0.06] border-emerald-500/15 text-emerald-300";

// ── Utility ──
export const flexCenter = "flex items-center justify-center";
export const flexBetween = "flex items-center justify-between";
export const flexGap2 = "flex items-center gap-2";
export const flexGap3 = "flex items-center gap-3";
export const textMuted = "text-xs text-white/30";
export const textSecondary = "text-sm text-white/50";
export const textPrimary = "text-sm text-white/90 font-medium";
export const dividerClass = "h-px bg-white/[0.06] my-4";
export const progressBar = "h-1.5 rounded-full bg-white/[0.06] overflow-hidden";
export const progressFill = "h-full rounded-full transition-all duration-300";
export const iconBtn = "p-1 border-none bg-transparent cursor-pointer text-white/20 hover:text-white/50 transition-colors";
export const filterSelect = "bg-white/5 border border-white/10 rounded-md px-2 py-1.5 text-xs text-white/70";
export const chipBadge = "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border";

// ── Table (extended) ──
export const tableWrapper = "overflow-x-auto";
export const tableClass = "w-full border-collapse text-xs";
export const tableHeadRow = "border-b border-white/[0.08]";
export const tableBodyRow = "border-b border-white/[0.04] hover:bg-white/[0.03] transition-colors";
export const thStyle = "text-left text-[11px] uppercase tracking-wider text-white/30 font-medium py-2.5 px-3";
export const tdStyle = "py-2.5 px-3 text-white/70";

// ── KPI Cards ──
export const kpiCard = "p-4 bg-white/[0.03] border border-white/[0.08] rounded-[10px]";
export const kpiValue = "text-[22px] font-bold text-white";
export const kpiLabel = "text-[11px] text-white/35 mt-0.5";

// ── Common Inline Style Objects (for components using inline styles) ──
// NOTE: Prefer Tailwind classes above. These exist for backward compat.
export const inlineStyles = {
  card: { background: "var(--bg-card)", border: "1px solid var(--border-primary)", borderRadius: 12 },
  cardHeader: { padding: "16px 20px", borderBottom: "1px solid var(--border-subtle)", display: "flex", alignItems: "center", justifyContent: "space-between" },
  input: { width: "100%", padding: "8px 12px", borderRadius: 8, border: "1px solid var(--border-input)", background: "var(--bg-input)", color: "var(--text-primary)", fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" },
  select: { padding: "8px 12px", borderRadius: 8, border: "1px solid var(--border-input)", background: "var(--bg-input)", color: "var(--text-primary)", fontSize: 13, fontFamily: "inherit", outline: "none" },
  label: { fontSize: 12, fontWeight: 500, color: "var(--text-tertiary)", marginBottom: 4, display: "block" },
  heading: { fontSize: 14, fontWeight: 600, color: "var(--text-primary)" },
  muted: { fontSize: 12, color: "var(--text-muted)" },
  divider: { height: 1, background: "var(--border-subtle)", margin: "16px 0" },
  kpiCard: { padding: 16, background: "var(--bg-card)", border: "1px solid var(--border-subtle)", borderRadius: 10 },
  kpiValue: { fontSize: 22, fontWeight: 700, color: "var(--text-primary)" },
  kpiLabel: { fontSize: 11, color: "var(--text-tertiary)", marginTop: 2 },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 12 },
  th: { textAlign: "left", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--text-muted)", fontWeight: 500, padding: "10px 12px", borderBottom: "1px solid var(--border-primary)" },
  td: { padding: "10px 12px", borderBottom: "1px solid var(--border-subtle)", color: "var(--text-secondary)" },
  tabBtn: (active) => ({
    flex: "1 1 auto", padding: "8px 14px", borderRadius: 8, border: "none",
    cursor: "pointer", fontFamily: "inherit", fontSize: 12,
    fontWeight: active ? 600 : 400,
    background: active ? "rgba(14,165,233,0.15)" : "transparent",
    color: active ? "#38bdf8" : "var(--text-tertiary)",
    display: "flex", alignItems: "center", justifyContent: "center", gap: 5,
    transition: "all 0.15s",
  }),
};
